import React from 'preact/compat';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import intersection from 'lodash/intersection';

import { locales as LOCALES, defaultLocale as DEFAULT_LOCALE }
  from '../data/locales';
import '../helpers/i18n';

const I18n = ({
  message, options, locale, html,
}) => {
  const text = i18next.t(message, { ...options, lng: locale });

  if (html) {
    // eslint-disable-next-line react/no-danger
    return <span dangerouslySetInnerHTML={{ __html: text }} />;
  }

  return <span>{text}</span>;
};

I18n.propTypes = {
  message: PropTypes.string.isRequired,
  options: PropTypes.shape({}),
  locale: PropTypes.string,
  html: PropTypes.bool,
};

I18n.defaultProps = {
  options: {},
  locale: DEFAULT_LOCALE,
  html: false,
};

function getJobLocale(job) {
  const locales = intersection(job.locales, LOCALES);
  const defaultLocale =
    locales.includes(DEFAULT_LOCALE) ? DEFAULT_LOCALE : locales[0];
  return locales
    .find(locale =>
      i18next.t('country', { lng: locale }) === job.country)
        || defaultLocale || DEFAULT_LOCALE;
}

export {
  I18n,
  getJobLocale,
};
